export default __webpack_public_path__ + "static/media/icons8-stack-overflow.8e88da2d.svg";